import styled from "styled-components";
import { colors, MediaQuery } from "ui-components";

const LandingWrapper = styled.div`
  padding-top: 60px;
  background-color: ${colors.whiteGrey}
`;

const LandingContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 60px);
`;

const LandingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  text-align: center;
  font-size: 15px;

  ${MediaQuery.tabletUp`max-width: 550px;`}
  ${MediaQuery.largeUp`max-width: 750px;`}
`;

const LandingActions = styled.div`
  display: flex;
  flex-direction: column;
`;

export {
  LandingActions,
  LandingContent,
  LandingContentWrapper,
  LandingWrapper
};



// WEBPACK FOOTER //
// ./src/landing/styled.js